import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';

export default function AlertDialog(props) {
  const { t } = useTranslation();
  const { open, onClose, children } = props;
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle style={{ textAlign: 'center' }} id="alert-dialog-title">{"Alerta!"}</DialogTitle>
      <DialogContent >
        <DialogContentText style={{ textAlign: 'center' }} id="alert-dialog-description">
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
        <Button onClick={onClose} style={{ backgroundColor: colors.Primary, color: 'white', padding: 10 }}>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog >
  );
}
